import script from "./CatalogSearchDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./CatalogSearchDrawer.vue?vue&type=script&setup=true&lang=js"

import "./CatalogSearchDrawer.vue?vue&type=style&index=0&id=c99453ce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c99453ce"]])

export default __exports__